import Grid from './Grid';
import GridExcel from './GridExcel';
import DataGrid from './DataGrid';
import DataGridMul from './DataGridMul';
import Tree from './Tree';
import Submit from './Submit';
import Button from './Button';
import Input from './Input';
import Password from './Password';
import DatePicker from './DatePicker';
import DataTable from './DataTable';
import DataOptions from './DataOptions';
import DataQuestionOptions from './DataQuestionOptions';
import DataInfo from './DataInfo';
import TextArea from './TextArea';
import Select from './Select';

import Birthday from './Birthday';
import Gender from './Gender';
import Email from './Email';
import Tel from './Tel';
import Upload from './Upload';
import Modal from './Modal';
import PrintSettings from './PrintSettings';

import org from './org';
import question from './question';
import employee from './employee';
import classes from './classes';
import student from './student';
import course from './course';
import syscode from './syscode';
import sysmodule from './sysmodule';
import evals from './evals';
import term from './term';
import lesson from './lesson';
import week from './week';
import stat from './stat';
import toolbar from './toolbar';
import file from './file';
import attachment from './attachment';
import evalitem from './evalitem';
import roles from './roles';
import GroupCharts from './GroupCharts';
import GridCloud from './GridCloud';
import jszg from './jszg';
import ciqa from './ciqa';
import listenGrid from './listenGrid'
import zgcp from './zgcp';
import GroupChartsNew from './GroupChartsNew';
import academy from './academy';
import GridAcademy from './GridAcademy';
import DataGridAcademy from './DataGridAcademy';
import termType from './termType';
import home from './home';
import secondCredit from './secondCredit';
import graduation from './graduation';
import supv from './supv';
import InputString from './InputString';
import InputInt from './InputInt';
import InputDouble from './InputDouble';
import academicGuidance from './academicGuidance';
import echarts from './echarts';
import unit from './ky'
import TreeSelect from './TreeSelect';
import TreeByCode from './TreeByCode';
import dossier from './dossier';
import project from './project';

export default {
    Grid,
    GridExcel,
    DataGrid,
    DataGridMul,
    DataOptions,
    DataQuestionOptions,
    Password,
    Select,
    Tree,
    DatePicker,
    TextArea,
    Birthday,
    Gender,
    Email,
    DataTable,
    Button,
    Upload,
    Modal,
    PrintSettings,
    DataInfo,
    Tel,
    Submit,
    Input,
    org,
    question,
    employee,
    classes,
    student,
    course,
    syscode,
    sysmodule,
    evals,
    term,
    lesson,
    week,
    stat,
    toolbar,
    file,
    attachment,
    evalitem,
    roles,
    GroupCharts,
    GridCloud,
    jszg,
    ciqa,
    listenGrid,
    zgcp,
    GroupChartsNew,
    academy,
    GridAcademy,
    DataGridAcademy,
    termType,
    home,
    secondCredit,
    graduation,
    supv,
    InputString,
    InputInt,
    InputDouble,
    academicGuidance,
    echarts,
    unit,
    TreeSelect,
    TreeByCode,
    dossier,
    project
}